import { render, staticRenderFns } from "./Observers.vue?vue&type=template&id=c818fa80&scoped=true&"
import script from "./Observers.vue?vue&type=script&lang=js&"
export * from "./Observers.vue?vue&type=script&lang=js&"
import style0 from "./Observers.vue?vue&type=style&index=0&id=c818fa80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c818fa80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c818fa80')) {
      api.createRecord('c818fa80', component.options)
    } else {
      api.reload('c818fa80', component.options)
    }
    module.hot.accept("./Observers.vue?vue&type=template&id=c818fa80&scoped=true&", function () {
      api.rerender('c818fa80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/templates/Observers.vue"
export default component.exports